import { create } from 'zustand'

/**
 * A request for the app shell to show a page, optionally with text for its ask
 * bar. Pulse panels sit outside the shell's props, so they post here and
 * `usePulseNavBridge` carries the request out. Each `go` is a fresh object, so
 * repeating the same request still fires.
 */
export const usePulseNavStore = create((set) => ({
  request: null,
  go: (path, text) => set({ request: { path, text: text ?? null } }),
  clear: () => set({ request: null }),
}))
